import React from "react";
import { FaCog, FaFileAlt } from "react-icons/fa";
import SettingsSectionShell, {
  SettingsSubgroupHeader,
} from "./SettingsSectionShell";
import SettingsFieldCard from "./SettingsFieldCard";
import SecuritySection from "./SecuritySection";
import PaymentSection from "./PaymentSection";
import valuesEqual from "./hooks/valuesEqual";

const COLOR = "blue";

// Log yapılandırması (MQTT yayını/seviye/kategori + ekran log yayını) tek bir
// iş konusudur — Sistem bölümü içinde kendi alt grubunda toplanır. Sıra da
// buradan gelir: önce yayın anahtarları, sonra süzgeçler.
//
// Başlık makinedeki menü adıyla birebir aynı ("Log") — teknisyen panelde ve
// makinede aynı ismi görmeli (kullanıcı kuralı).
export const LOG_KEYS = [
  "mqttLogActive",
  "displayLogActive",
  "mqttLogLevels",
  "mqttLogCategories",
];

/**
 * "Sistem" bölümü — cihazın kendisine ait yapılandırmanın tamamı tek sekmede:
 * Genel (dil/hata kodu/mod), Log, Şifre Ayarları ve Ödeme. Alt grupların
 * her biri kendi rengini ve başlığını korur.
 *
 * DİKKAT: yalnızca SUNUM birleşti. Yazma grupları ayrı kalır
 * (`profile.settings` / `profile.security` / `payment`) — sunucu süzgeci ve
 * rol şablonu anahtar yolları bu grupları ayrı tanır.
 */
export default function ProfileSettingsSection({
  data,
  onChange,
  originalData,
  security,
  originalSecurity,
  payment,
  originalPayment,
}) {
  const keys = data ? Object.keys(data) : [];
  const generalKeys = keys.filter((k) => !LOG_KEYS.includes(k));
  // Cihazdan gelen sırayı değil, LOG_KEYS sırasını uygula.
  const logKeys = LOG_KEYS.filter((k) => keys.includes(k));
  const securityKeys = security ? Object.keys(security) : [];
  const paymentKeys = payment ? Object.keys(payment) : [];

  const activeGroupCount = [generalKeys, logKeys, securityKeys, paymentKeys].filter(
    (g) => g.length > 0,
  ).length;
  if (activeGroupCount === 0) return null;

  // Tek grup kaldıysa (rol şablonu diğerlerini kapatmışsa) başlık gürültü olur.
  const showHeaders = activeGroupCount > 1;

  const renderCard = (k) => {
    const setting = data[k];
    const orig = originalData?.[k]?.value;
    const isChanged = orig !== undefined && !valuesEqual(setting.value, orig);
    return (
      <SettingsFieldCard
        key={k}
        setting={setting}
        onChange={(value) =>
          onChange({ group: "profile.settings", key: k, value })
        }
        isChanged={isChanged}
        originalValue={orig}
        color={COLOR}
      />
    );
  };

  const renderGroup = (id, icon, label, groupKeys) =>
    groupKeys.length > 0 && (
      <div key={id}>
        {showHeaders && (
          <SettingsSubgroupHeader
            icon={icon}
            title={label}
            count={groupKeys.length}
            color={COLOR}
          />
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {groupKeys.map(renderCard)}
        </div>
      </div>
    );

  return (
    <SettingsSectionShell
      icon={FaCog}
      title="Sistem Ayarları"
      subtitle="Genel, log, güvenlik ve ödeme yapılandırması"
      count={
        generalKeys.length +
        logKeys.length +
        securityKeys.length +
        paymentKeys.length
      }
      color={COLOR}
    >
      {renderGroup("general", FaCog, "Genel", generalKeys)}
      {renderGroup("log", FaFileAlt, "Log", logKeys)}
      <SecuritySection
        data={security}
        onChange={onChange}
        originalData={originalSecurity}
        showHeader={showHeaders}
      />
      <PaymentSection
        data={payment}
        onChange={onChange}
        originalData={originalPayment}
        showHeader={showHeaders}
      />
    </SettingsSectionShell>
  );
}
